module.exports = __webpack_public_path__ + "img/bio-pic-3-128-184.cf0dcbd9.jpg";